import { lazy } from "react";
import Loadable from "../../components/Loadings/Loadable";
import Logo from "../../assets/perigigi_icon.png";
import {
  LuAArrowDown,
  LuCircleCheckBig,
  LuCircleUserRound,
} from "react-icons/lu";
import NotFoundPage from "../../components/NotFound/NotFound";

//Perigigi

const MainLayout = Loadable(
  lazy(() => import("../../components/Layouts/MainLayout")),
);

// Auths
const SignInPage = Loadable(lazy(() => import("../../screens/auths/SignIn")));

//Register
const RegisterPage = Loadable(
  lazy(() => import("../../screens/auths/Register")),
);

//Home
const HomePage = Loadable(lazy(() => import("../../screens/mains/home")));

//Patients
const PatientsPage = Loadable(
  lazy(() => import("../../screens/mains/patients")),
);

const AddPatientsPage = Loadable(
  lazy(() => import("../../screens/mains/patients/fragments/add_patient")),
);

const DetailPatientPage = Loadable(
  lazy(() => import("../../screens/mains/patients/fragments/detail_patient")),
);

// const DetailsPatientPage = Loadable(
//   lazy(() => import("../../screens/mains/patients/fragments/details_patient"))
// );

//Create
const CreatePage = Loadable(lazy(() => import("../../screens/mains/create")));

const CreateExaminationPage = Loadable(
  lazy(() => import("../../screens/mains/create/fragments/create_examination")),
);
const CreatePrescriptionPage = Loadable(
  lazy(() =>
    import("../../screens/mains/create/fragments/create_prescription"),
  ),
);

const CreateAppointmentPage = Loadable(
  lazy(() => import("../../screens/mains/create/fragments/create_appointment")),
);

const CreateReportsPage = Loadable(
  lazy(() => import("../../screens/mains/create/fragments/create_reports")),
);

//Payment
const PaymentPage = Loadable(lazy(() => import("../../screens/mains/payment")));

//Agenda
const AgendaPage = Loadable(lazy(() => import("../../screens/mains/agenda")));

// Account Page
const AccountPage = Loadable(lazy(() => import("../../screens/mains/account")));

const TreatmentPage = Loadable(
  lazy(() =>
    import("../../screens/mains/account/fragments/treatment/Treatment"),
  ),
);

const TemplatePage = Loadable(
  lazy(() => import("../../screens/mains/account/fragments/template/Template")),
);
const SubscriptionPage = Loadable(
  lazy(() =>
    import("../../screens/mains/account/fragments/subscription/Subscription"),
  ),
);

const ResetPasswordPage = Loadable(
  lazy(() => import("../../screens/auths/ResetPasswordPage")),
);

//Perigigi
const appRoutes = [
  { path: "signin", element: <SignInPage /> },
  { path: "register", element: <RegisterPage /> },
  { path: "reset-password", element: <ResetPasswordPage /> },

  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
    ],
  },
  {
    path: "/patients",
    element: <MainLayout />,
    children: [
      {
        path: "",
        element: <PatientsPage />,
      },
      {
        path: "add-patient",
        element: <AddPatientsPage />,
      },
      {
        path: ":id",
        element: <DetailPatientPage />,
      },
      // {
      //   path: ":id",
      //   element: <DetailsPatientPage />,
      // },
    ],
  },
  {
    path: "/create",
    element: <MainLayout />,
    children: [
      {
        path: "",
        element: <CreatePage />,
      },
      {
        path: "create-examination",
        element: <CreateExaminationPage />,
      },
      {
        path: "create-prescription",
        element: <CreatePrescriptionPage />,
      },

      {
        path: "create-appointment",
        element: <CreateAppointmentPage />,
      },
      {
        path: "create-reports",
        element: <CreateReportsPage />,
      },
    ],
  },
  {
    path: "/payment",
    element: <MainLayout />,
    children: [
      {
        path: "",
        element: <PaymentPage />,
      },
    ],
  },
  {
    path: "/agenda",
    element: <MainLayout />,
    children: [
      {
        path: "",
        element: <AgendaPage />,
      },
    ],
  },
  {
    path: "/account",
    element: <MainLayout />,
    children: [
      {
        path: "profile",
        element: <AccountPage />,
      },
      {
        path: "treatment",
        element: <TreatmentPage />,
      },
      {
        path: "template",
        element: <TemplatePage />,
      },
      {
        path: "subscription",
        element: <SubscriptionPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFoundPage />,
  },
];

export default appRoutes;
